module.exports = __webpack_public_path__ + "45c1d1c9da6aa7d7170c0d067cffa8e0.glb";